<style>
.advanced-condition-button {
  position: relative;
  top: 28px;
  left: -8px;
}

.noConditionButton {
  margin-left: 0px !important;
}

.noConditionButtonWrapper {
  margin-top: 0px !important;
}

</style>

<template>
  <div>
    <div v-for="subQueries in BreakInSubQueries(queries)">
      <div
          class="query-component"
          :class="[(checkFirstOccurance(subQueries)) || checkAdvancedGroup(queries) ? 'isGroup' : null]"
          v-bind:style="[(checkFirstOccurance(subQueries)) ? {marginLeft : '75px', paddingLeft: '40px'} : {marginLeft : '0px'}]"
          style="padding-top:20px;"
      >
        <div v-bind:style="[(checkFirstOccurance(subQueries)) ? {marginLeft : '0px'} : {marginLeft : '35px'}]"
             v-for="query in subQueries">
          <div class="group-condition" v-if="CheckFirstCondition(query, queries)">
            <div class="dropdown and-or-condition">
              <button class="btn btn-secondary apply-btn-color dropdown-toggle" type="button" id="dropdownMenuButton"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ groupConditionFind(query.group_id, groupCondition) }}
              </button>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <a class="dropdown-item" v-on:click="groupConditionSelector('AND',query.group_id)"
                   href="javascript:void(0)">AND</a>
                <a class="dropdown-item" v-on:click="groupConditionSelector('OR',query.group_id)"
                   href="javascript:void(0)">OR</a>
              </div>
            </div>
          </div>

          <div :style="{ marginTop : 0 + 'px' }">
            <div class="col-sm-12 p-0">
              <div class="group" style="position: relative;">
                <div class="dropdown and-or-condition" style="position: absolute; top: 0; left: -56px;"
                     v-if="query.fieldConcatValue != undefined && checkFirstElement(query)">
                  <button class="btn btn-secondary apply-btn-color dropdown-toggle" type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {{ query.operator }}
                  </button>
                  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <a class="dropdown-item" v-on:click="operatorCondition('AND',query.level,query.id)"
                       href="javascript:void(0)">AND</a>
                    <a class="dropdown-item" v-on:click="operatorCondition('OR',query.level,query.id)"
                       href="javascript:void(0)">OR</a>
                  </div>
                </div>
                <div class="company-desc-value" v-if="!query.isGroup">
                  <div v-on:click="automationEditState($event,query.level,query.id)">
                    <p>{{ conditionFlag(query.conditionRecordType) }}{{
                        query.fieldTranslationsLabel
                      }}&nbsp;{{ lang[query.having] }}</p>
                    <span v-if="query.has_value">{{ havingValueTranslate(query) }}</span>
                    <span v-else>{{ query.fieldConcatValue }}</span>
                    <i class="fa fa-caret-down" aria-hidden="true"></i>
                  </div>
                  <a href="javascript:void(0)"><i class="fa fa-times" aria-hidden="true"
                                                  v-on:click.stop.prevent="removeQueryByClick(query.level,query.id)"></i></a>
                </div>
              </div>
            </div>

            <!-- {{ automation.order }} -->

            <form autocomplete="off" v-click-outside="outside" v-if="query.modal">
              <div class="popup-container-main"
                   v-bind:style="[popup_modal_top_css != 0 ? {top : popup_modal_top_css} : null]">
                <div class="popup-container">
                  <div class="popup-search-filter">
                    <input
                        class="form-control table-filter-row-search"
                        v-on:keyup="searchSubmit($event)"
                        id="search-keyword"
                        type="Search"
                        :placeholder="lang.search+'..'"
                    >
                    <i class="fa fa-search" aria-hidden="true"></i>
                    <div class="workflow-selected-field" v-if="selected_text_seen">
                      <span>{{ lang.select + ' ' + lang.field }}</span>
                    </div>
                  </div>
                  <div class="workflow-accordion-container">
                    <transition name="slide" v-if="selected_accordion_seen">
                      <accordion-component
                          :accrodionState="accrodionState"
                          :whenQueryEdit="whenQueryEdit"
                          :savedInput="savedInput"
                          :level="query.level"
                          :tableWithValues="tableWithValues"
                          :tableField="tableField"
                          :table="table"
                          :tables="tables"
                          :fields="fields"
                          :lang="lang"
                          :whenshould="whenshould"
                          v-on:getInput="getInput"
                          v-on:backToprevious="backToprevious"
                          v-on:listenerChild="AccordianListener"
                          v-on:ResetConditionBtnOccurenceArray="ResetConditionBtnOccurenceArray"
                      ></accordion-component>
                    </transition>
                    <div class="company-selected-section" v-if="moreCondition">
                      <img :src="url+'/icons/com-arrow-down.svg'" v-on:click.stop.prevent="previousCondition()">
                      <span>{{ fieldTranslationsLabel }}</span>
                      <div class="row-data-dropdown">
                        <p class="row-data-selected set-selected-condition">{{ lang[having] }}</p>
                        <b-dropdown class="m-md-2" name="condition" v-model="having">
                          <b-dropdown-item
                              v-for="condition in GetConditions()"
                              :key="condition.dropdown_value"
                              :value="condition.dropdown_value"
                              @click="having = condition.having">
                            {{ lang[condition.having] }}
                          </b-dropdown-item>
                        </b-dropdown>
                      </div>
                      <accordion-component
                          :accrodionState="accrodionState"
                          :whenQueryEdit="whenQueryEdit"
                          :savedInput="savedInput"
                          :level="query.level"
                          :tableWithValues="tableWithValues"
                          :tableField="tableField"
                          :table="table"
                          :tables="tables"
                          :lang="lang"
                          :whenshould="whenshould"
                          v-on:getInput="getInput"
                          v-on:backToprevious="backToprevious"
                          v-on:listenerChild="AccordianListener"
                          v-on:ResetConditionBtnOccurenceArray="ResetConditionBtnOccurenceArray"
                      ></accordion-component>
                      <button class="btn btn-outline-primary btn-apply-condition"
                              v-on:click.stop.prevent="apply(query.level,query.id)">{{ lang.apply }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <span class="remove-query" v-if="(checkFirstOccurance(subQueries))"
                v-on:click.stop.prevent="removeQueryGroup(query.group_id)"><i class="fas fa-times"></i></span>

          <div class="btn-occurance" v-if="showAddConditionBtn(query, queries)">
            <div class="btn-group"
                 v-bind:class="{ noConditionButtonWrapper: addConditionBtnCount(subQueries[subQueries.length -1], RawQueryStructure) == 1 }">
              <button
                  class="btn btn-sm query-btn"
                  v-on:click.stop.prevent="openAutomationModal(subQueries[subQueries.length -1].id, null, $event)"
                  v-bind:class="{ noConditionButton: addConditionBtnCount(subQueries[subQueries.length -1], RawQueryStructure) == 1 }"
              > + {{ lang.add_condition }}
              </button>
              <button class="btn btn-outline-primary query-btn-group btn-sm dropdown-toggle"
                      v-on:click.stop.prevent="addconditionGroup($event,subQueries[subQueries.length -1].level,subQueries[subQueries.length -1],subQueries[subQueries.length -1].subLevel+1,(subQueries[subQueries.length -1].order+1))"></button>
            </div>
          </div>
        </div>


        <div v-if="SubQueryExists(subQueries)">
          <QueryComponent
              :queries="subQueries[subQueries.length -1].queries"
              :addConditionBtnOccurence="addConditionBtnOccurence"
              :RawQueryStructure="RawQueryStructure"
              :level="subQueries[subQueries.length -1].level"
              :query="subQueries[subQueries.length -1]"
              :groupId="subQueries[subQueries.length -1].group_id"
              :url="url"
              :db_exactTable_name="db_exactTable_name"
              :table="table"
              :tables="tables"
              :modal="subQueries[subQueries.length -1].modal"
              :subLevel="subQueries[subQueries.length -1].subLevel"
              :depth="depth + 1"
              :operator="subQueries[subQueries.length -1].operator"
              :id="subQueries[subQueries.length -1].id"
              :isGroup="subQueries[subQueries.length -1].isGroup"
              :order="order"
              :fields="fields"
              :groupCondition="groupCondition"
              :conditions="conditions"
              :conditionsForNumber="conditionsForNumber"
              :timeZone="timeZone"
              :lang="lang"
              :whenshould="whenshould"
              @automationEditState="automationEditState"
              @ApplyChildFunction="ApplyChildFunction"
              @RebulidAutomationQueryTree="RebulidAutomationQueryTree"
              @UpdateConditionBtnOccurenceArray="UpdateConditionBtnOccurenceArray"
              @ResetConditionBtnOccurenceArray="ResetConditionBtnOccurenceArray"
              @SetSubLevelValue="SetSubLevelValue"
              @groupConditionSelector="groupConditionSelector"
              @removeQuery="removeQuery"
              @removeQueryGroup="removeQueryGroup"
              @emitconditionGroup="emitconditionGroup"
          >
          </QueryComponent>
        </div>

        <div class="advanced-condition-button">
          <button class="advance-con-btn mt-2"
                  v-on:click.stop.prevent="openAutomationModal(subQueries[subQueries.length -1].id,true, $event)">
            <i class="fa fa-plus"></i> {{ lang.add_advanced_condition }}
          </button>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import axios from 'axios';
import vco from "v-click-outside";
import uniqid from "uniqid";

Vue.use(vco);

export default {
  props: [
    'RawQueryStructure',
    'addConditionBtnOccurence',
    'level',
    'table',
    'tables',
    'fields',
    'url',
    'conditions',
    'conditionsForNumber',
    'db_exactTable_name',
    'queries',
    'subLevel',
    'operator',
    'id',
    'isGroup',
    'order',
    'query',
    'modal',
    'depth',
    'groupId',
    'groupCondition',
    'timeZone',
    'lang',
    'whenshould',
  ],
  data() {
    return {
      selectedOrInputValue: '',
      fieldTranslationsLabel: null,
      check_not_empty: 0,
      has_value: 0,
      moreCondition: false, // for second section show of accordion
      accrodionState: 1,
      ApplyId: null,
      QueryEditState: false,
      GlobalQueryParentId: null,
      OrderId: 0,
      whenQueryEdit: null,
      selected_accordion_seen: null,
      selected_text_seen: null,
      tableWithValues: null,
      conditionRecordType: null,
      conditionTranslationsLabel: null,
      savedInput: null,
      having: 'is',
      tableField: null,
      fieldConcatValue: null,
      group_id: 0,
      parent_group_id: 0,
      hasAdvanced: false,
      component: true,
      popup_modal_top_css: 0,
      selected_field_type: null,
      previous_custom_input: null, // when edit query with custom value
      flag: 0,
    }
  },
  name: 'QueryComponent',
  created() {
    // console.log(this.whenshould);
  },
  mounted() {
    this.outside();
  },
  computed: {
    SortedQueries: function () {
      return _.orderBy(this.RawQueryStructure, 'order', 'desc');
    }
  },
  watch: {
    having() {
      this.ResetConditionBtnOccurenceArray();
    }
  },
  beforeUpdate() {

  },
  methods: {
    BreakInSubQueries(_queries) {
      _queries = _.orderBy(_queries, 'group_id', 'asc');

      let _obj = {};
      // get the values based on group ids
      for (let i = 0; i < _queries.length; i++) {
        if (_obj[_queries[i].group_id] == undefined) {
          _obj[_queries[i].group_id] = [];
        }

        _obj[_queries[i].group_id].push(_queries[i]);
      }

      return _obj;
    },
    CheckFirstCondition(_query, _queries) {
      let _formated_query = this.BreakInSubQueries(_queries);
      var firstKey = Object.keys(_formated_query)[0];

      if (_query.parent_group_id == 0 && _query.group_id == firstKey) {

        if (_query.group_id == firstKey) {
          return false;
        }
      }

      return true;
    },
    GetConditions() {

      if (this.selected_field_type == 'number' || this.selected_field_type == 'formula' || this.selected_field_type == 'amount') {
        return this.conditionsForNumber;
      }

      return this.conditions;
    },
    checkAdvancedGroup(subQueries) {
      let _queries = [];

      for (let i = 0; i < subQueries.length; i++) {
        let _index = _queries.indexOf(subQueries[i].group_id);

        if (_index == -1) {
          _queries.push(subQueries[i].group_id);
        }
      }

      if (_queries.length > 1) {
        return true;
      }

      return false;
    },
    ReConditionBtnOccurenceArray() {
      this.$emit('ResetConditionBtnOccurenceArray');
    },
    havingValueTranslate(query) {
      return this.table + '.' + this.lang.having_value;
    },
    SubQueryExists(queries) {
      let _subQueries = queries[queries.length - 1].queries;

      if (_subQueries != undefined && _subQueries.length != 0) {
        return true;
      } else {
        return false;
      }

      // console.log(queries.length);
    },
    checkIsGroup(_queries) {
      if (_queries.length != 0) {
        let _subQueries = _queries[_queries.length - 1].queries;
        if (_subQueries.length != 0) {
          return true;
        }
      }

      return false;
    },
    checkFirstElement(query) {
      let queries = this.SortedQueries;
      let _index = queries.findIndex(x => x.group_id == query.group_id && x.fieldConcatValue != undefined);

      if (_index > -1) {
        if (queries[_index].id == query.id) {
          return false;
        }
      }

      return true;
    },
    checkFirstOccurance(queries) {

      if (queries[0].parent_group_id == 0) {
        return false;
      }
      return true;
    },
    showAdvancedConditionButton(query) {
      if (!this.addAdvancedConditionButtonShown) {
        this.addAdvancedConditionButtonShown = true;
        return true;
      } else {
        return true;
      }
    },
    operatorCondition(operatortext, level, id) {
      this.manipulateRawQueryStructure(operatortext, level, id);
    },
    groupConditionFind(groupId, groupCondition) {
      for (var group_index in groupCondition) {
        if (groupCondition[group_index].group_id == groupId) {
          return this.groupCondition[group_index].condition;
        }
      }

      return 'AND'; // Default
    },
    groupConditionSelector(SelectedValue, groupId) {

      for (var group_index in this.groupCondition) {
        if (this.groupCondition[group_index].group_id == groupId) {
          this.groupCondition[group_index].condition = SelectedValue;
        }
      }

      this.$emit('groupConditionSelector', SelectedValue, groupId);
      this.ResetConditionBtnOccurenceArray();
    },
    automationEditState(event, level, id,) {

      let field_id = null;

      for (let x in this.RawQueryStructure) {
        if (id == this.RawQueryStructure[x].id) {
          this.whenQueryEdit = this.RawQueryStructure[x];
          this.RawQueryStructure[x].modal = true;
          this.having = this.RawQueryStructure[x].having; // when edit set is,ends_with,start_with e.t.c
          field_id = this.RawQueryStructure[x].column_primary;
          if (this.RawQueryStructure[x].check_not_empty == 1) {
            this.savedInput = this.RawQueryStructure[x].value.toString();
            this.fieldConcatValue = this.table + '.' + this.RawQueryStructure[x].value.join(); // for fronted purpose e.g tablename.value
            this.check_not_empty = this.RawQueryStructure[x].check_not_empty;
            this.selectedOrInputValue = this.RawQueryStructure[x].value;
          } else {
            this.selectedOrInputValue = this.RawQueryStructure[x].value;
            this.fieldConcatValue = this.GetConcatValue(this.RawQueryStructure[x].value); // for fronted purpose tablename.value
            this.savedInput = null;
          }
          this.has_value = this.RawQueryStructure[x].has_value;
        } else {
          this.RawQueryStructure[x].modal = false;
        }
      }

      this.QueryEditState = true;

      // / when modal open with saved data state


      if (this.whenQueryEdit) {
        axios.post('/get-fields-value', {
          table: this.db_exactTable_name,
          field: this.whenQueryEdit.tableField,
          field_id: field_id,
          timeZone: this.timeZone
        }).then(response => {
          this.tableWithValues = response.data.field_value;
          this.selected_field_type = response.data.field_type;
          this.ResetConditionBtnOccurenceArray();
          this.fieldTranslationsLabel = this.whenQueryEdit.conditionRecordType == 'old' ? 'Old Values.' + response.data.field_label : response.data.field_label;
          this.conditionTranslationsLabel = response.data.field_label;
          this.conditionRecordType = this.whenQueryEdit.conditionRecordType == 'old' ? 'old' : 'new';
        }); // get the value of the field

        if (this.whenQueryEdit.check_not_empty == 0) {
          this.accrodionState = 3;
        } else {
          this.accrodionState = 2;
        }
        this.tableField = this.whenQueryEdit.tableField;
        this.tableField_id = this.whenQueryEdit.column_primary;
        this.selected_text_seen = false;
        this.moreCondition = true;
        this.selected_accordion_seen = false;
      }

      // design fix for the automation modal
      let _parent_group_div = event.target.parentNode.closest('.query-component');
      if (_parent_group_div != null) {
        let _parent_group_div_rect = _parent_group_div.getBoundingClientRect();
        let _diff_y = event.target.getBoundingClientRect().top - _parent_group_div_rect.top;

        this.popup_modal_top_css = (_diff_y + 36) + "px";
      } else {
        this.popup_modal_top_css = 0;
      }

      this.RebulidAutomationQueryTree();
      this.ResetConditionBtnOccurenceArray();
    },
    removeQueryByClick(level, id) {
      this.removeQuery(id);
    },
    removeQuery(id) {
      this.$emit('removeQuery', id);
    },
    removeQueryGroup(groupId) {
      this.$emit('removeQueryGroup', groupId);
    },
    showAddConditionBtn(automation, queries) {
      let group_id = automation.group_id;

      // handle the undefined exception
      if (this.addConditionBtnOccurence[group_id] == undefined) {
        this.UpdateConditionBtnOccurenceArray({group_id: group_id, value: null});
      }

      let _index = this.addConditionBtnOccurence[group_id].indexOf(automation.id);

      // check whether the id exists or not
      if (_index == -1) {
        this.UpdateConditionBtnOccurenceArray({group_id: group_id, value: automation.id});
      }

      var count = queries.reduce(function (n, query) {
        return n + (query.group_id == group_id);
      }, 0);

      // check the count
      if (this.addConditionBtnOccurence[group_id].length == count) {
        return true;
      } else {
        return false;
      }
    },
    addConditionBtnCount(automation, queries) {
      let group_id = automation.group_id;

      var count = queries.reduce(function (n, query) {
        return n + (query.group_id == group_id);
      }, 0);

      return count;
    },
    UpdateConditionBtnOccurenceArray(data) {
      this.$emit('UpdateConditionBtnOccurenceArray', data);
    },
    ResetConditionBtnOccurenceArray() {
      this.$emit('ResetConditionBtnOccurenceArray');
    },
    SetSubLevelValue(data) {
      this.$emit('SetSubLevelValue', data);
    },
    openAutomationModal(id, has_advanced = null, event = null) {
      this.GlobalQueryParentId = 0;
      this.OrderId = 0;
      this.SetSubLevelValue(0);
      this.check_not_empty = 0;
      this.has_value = 0;

      // close all the modals
      for (let index in this.RawQueryStructure) {
        this.RawQueryStructure[index].modal = false;
      }

      let _index = this.RawQueryStructure.findIndex(x => x.id == id);

      if (_index > -1) {
        this.RawQueryStructure[_index].modal = true;
        this.GlobalQueryParentId = this.RawQueryStructure[_index].id;
        this.OrderId = this.RawQueryStructure[_index].order; // global
        this.SetSubLevelValue(this.RawQueryStructure[_index].subLevel);
        this.group_id = this.RawQueryStructure[_index].group_id;
        this.parent_group_id = this.RawQueryStructure[_index].parent_group_id;
        // set In global variable which was need In apply function
      }

      if (has_advanced) {
        this.hasAdvanced = true; // when click advanced condtion
      }

      // design fix for the automation modal
      let _parent_group_div = event.target.parentNode.closest('.query-component');
      if (_parent_group_div != null) {
        let _parent_group_div_rect = _parent_group_div.getBoundingClientRect();
        let _diff_y = event.target.getBoundingClientRect().top - _parent_group_div_rect.top;

        this.popup_modal_top_css = (_diff_y + 34) + "px";
      } else {
        this.popup_modal_top_css = 0;
      }

      this.QueryEditState = false;
      this.ResetConditionBtnOccurenceArray();
    },
    addconditionGroup(event, level, automation, subLevel, order) {

      let data = {
        level: level,
        automation: automation,
        subLevel: subLevel,
        order: order,
      };
      this.emitconditionGroup(data);
    },
    emitconditionGroup(data) {
      this.$emit('emitconditionGroup', data);
      /* Push group condition parent props */
      this.ResetConditionBtnOccurenceArray();
    },
    manipulateRawQueryStructure(operatortext = null, level = null, id = null) {
      for (let x in this.RawQueryStructure) {
        if (this.RawQueryStructure[x].id == id) {
          if (!operatortext) {
            this.RawQueryStructure[x].remove = true; // condition remove
          } else {
            this.RawQueryStructure[x].operator = operatortext; // update operator
            this.RawQueryStructure[x].update = true;
          }
        }
      }

      this.RebulidAutomationQueryTree();
    },
    RebulidAutomationQueryTree() {
      this.$emit('RebulidAutomationQueryTree');
    },
    outside() {

      this.previousCondition();

      if (this.flag == 0) {
        if (this.whenQueryEdit) {
          if (this.whenQueryEdit.check_not_empty == 1) {
            if (this.previous_custom_input) {
              this.fieldConcatValue = this.table + '.' + this.previous_custom_input;
              this.whenQueryEdit.fieldConcatValue = this.fieldConcatValue;
              this.whenQueryEdit.value = this.previous_custom_input;
            }
          }
        }
      }

      for (let div in this.RawQueryStructure) {
        this.RawQueryStructure[div].modal = false;
      }
      this.selectedOrInputValue = null;
      this.having = 'is';
      this.whenQueryEdit = null; // push in this variable when edit the query again
      this.hasAdvanced = false;
      this.flag = 0;
      this.RebulidAutomationQueryTree();
    },
    previousCondition() {
      this.accrodionState = 1;
      this.moreCondition = false;
      this.selected_accordion_seen = true;
      this.selected_text_seen = true;
    },
    getInput(event) { // get custom input
      this.selectedOrInputValue = [event.target.value];
      this.check_not_empty = 1;
      this.has_value = 0;
      this.fieldConcatValue = this.table + '.' + event.target.value;
      this.flag = 1;
    },
    backToprevious(sectionId) {

      if (this.whenQueryEdit) {
        if (this.whenQueryEdit.check_not_empty == 1) {
          if (this.whenQueryEdit.value.length > 0) {
            this.previous_custom_input = this.whenQueryEdit.value;
          }

          this.whenQueryEdit.value = [];
          this.fieldConcatValue = this.GetConcatValue(this.whenQueryEdit.value);
          this.whenQueryEdit.fieldConcatValue = this.fieldConcatValue;
        }
      }

      this.accrodionState = sectionId;
      this.selectedOrInputValue = null;
      this.fieldConcatValue = null;
      this.check_not_empty = 0;
    },
    GetConcatValue(selectionObj) {

      let values = '';
      for (var fieldValue in selectionObj) {
        if (selectionObj[fieldValue].fieldName != undefined) {
          values += selectionObj[fieldValue].fieldName + ',';
        } else {
          values += selectionObj[fieldValue] + ',';
        }
      }
      var lastIndex = values.lastIndexOf(',');
      values = values.substring(0, lastIndex);
      values = this.table + '.' + values;

      return values;
      // for fronted purpose e.g tablename.value
    },
    AccordianListener(selected_value = null, selectionObj = null, level = null) {

      this.fieldConcatValue = null;
      let havingValue = null;


      if (selected_value != 'selection') { // If 'selection' string come from child component then hide current one e.g table field

        this.selected_field_type = selected_value.field_type;

        axios.post('/get-fields-value', {
          table: this.db_exactTable_name,
          field: selected_value.field_name,
          field_id: selected_value.id,
          timeZone: this.timeZone
        }).then(response => {
          this.tableWithValues = response.data.field_value;
          this.fieldTranslationsLabel = selected_value.record == 'old' ? 'Old Values.' + response.data.field_label : response.data.field_label;
          this.conditionTranslationsLabel = response.data.field_label;
          this.ResetConditionBtnOccurenceArray();
          this.conditionRecordType = selected_value.record != undefined ? 'old' : 'new';
        }); // get the value of the field

        if (this.whenQueryEdit) {
          if (this.whenQueryEdit.check_not_empty == 1) {
            this.accrodionState = 2;
            this.fieldConcatValue = this.GetConcatValue(this.whenQueryEdit.value);
            this.check_not_empty = 1;
          } else {
            this.accrodionState = 3;
          }
        } else {
          this.accrodionState = 3;
        }

        this.tableField = selected_value.field_name;
        this.tableField_id = selected_value.id;
        this.selected_text_seen = false;
        this.moreCondition = true;
        this.selected_accordion_seen = false;

      } else {
        if (!selectionObj) {
          this.accrodionState = 2;
        } else {
          for (var key in selectionObj) {

            for (let value in selectionObj[key]) {
              if (selectionObj[key][value].fieldName == 'Having Value') {
                havingValue = selectionObj[key][value].fieldName;
              }
            }

            if (!havingValue) {
              if (selectionObj[key].length > 0) {
                this.selectedOrInputValue = selectionObj[key]; // DB values column data
                this.has_value = 0;
                this.fieldConcatValue = this.GetConcatValue(selectionObj[key]); // for fronted purpose e.g tablename.value
              }
            } else {
              this.selectedOrInputValue = [havingValue];
              this.fieldConcatValue = this.table + '.' + havingValue; // for fronted purpose e.g tablename.havingvalue
            }
          }

          if (havingValue == 'Having Value') {
            this.check_not_empty = 0;
            this.has_value = 1;
            this.apply(level);
          }
        }
      }
    },
    searchSubmit(event) {
      let keyword = event.target.value.toLowerCase();
      $("#filterSearch *").filter(function () {
        $(this).toggle($(this).text().toLowerCase().indexOf(keyword) > -1);
      });
    },
    apply(level) {

      let query_id = null;

      if (this.whenQueryEdit) {
        query_id = this.whenQueryEdit.id;

        if (this.selectedOrInputValue) {
          if (!this.selectedOrInputValue[0]) {
            this.selectedOrInputValue = null;
          }
        }
      }

      if (!this.selectedOrInputValue) {
        this.selectedOrInputValue = this.previous_custom_input;
      }

      if (!this.selectedOrInputValue || this.selectedOrInputValue == undefined) {
        alert('Please select some table value');
        return;
      }
      // create at time
      let _date = new Date();
      _date.setMilliseconds(0);
      let time_stamp = _date.getTime() / 1000;

      let data = {
        having: this.having,
        tableField: this.tableField,
        tableField_id: this.tableField_id,
        fieldConcatValue: this.fieldConcatValue,
        modal: false,
        check_not_empty: this.check_not_empty,
        selectedOrInputValue: this.selectedOrInputValue,
        update: true,
        has_value: this.has_value,
        GlobalQueryParentId: this.GlobalQueryParentId,
        OrderId: this.OrderId,
        subLevel: this.subLevel,
        QueryEditState: this.QueryEditState,
        level: level,
        query_id: query_id,
        group_id: this.group_id,
        parent_group_id: this.parent_group_id,
        advanced: this.hasAdvanced,
        fieldTranslationsLabel: this.conditionTranslationsLabel,
        id: !query_id ? time_stamp : this.whenQueryEdit.id,
        conditionRecordType: this.conditionRecordType,
      };

      this.ApplyChildFunction(data);
      this.outside();
      this.RebulidAutomationQueryTree();
    },
    ApplyChildFunction(data) {
      this.$emit('ApplyChildFunction', data);
    },
    conditionFlag(ConationFlagValue) {
      if (ConationFlagValue == 'old') {
        return 'Old Values.';
      }
    }
  }
}
</script>